import { authenticationSuccess } from './AuthenticationSuccess/AuthenticationSuccess';
import type { ActionReducerMapBuilder } from '@reduxjs/toolkit/src/mapBuilders';
import { IAuthenticationState } from '../../Slices/Authentication/AuthenticationSlice';

export const authenticationExtraReducers = (builder: ActionReducerMapBuilder<IAuthenticationState>) => {
  authenticationSuccess(builder);
};
